import { useTranslation } from '@thoughtspot/i18n';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { Suspense } from 'react';
import { BasePageContext } from "../../contexts/basepage-context";
import { SettingHeaderComponent } from './setting/setting-header';
import { SettingSeperator } from './setting-seperator';
import styles from './setting-spotter-connectors.module.scss';
const learnMore = { text: '', url: '', newWindow: false };
const ArsenalConnectorsList = React.memo(() => {
    const { connectorsComponents } = BasePageContext();
    const { AdminSettingsConnectorsListContainer } = connectorsComponents || {};
    if (!AdminSettingsConnectorsListContainer) {
        return null;
    }
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)) },
        React.createElement(AdminSettingsConnectorsListContainer, null)));
});
export const SettingSpotterConnectors = React.memo(({ actionHandler }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: styles.settingSpotterConnectors },
        React.createElement(SettingSeperator, null),
        React.createElement(SettingHeaderComponent, { settingName: t('arsenal.settings.connectors.page.title'), settingSubTitle: t('arsenal.settings.connectors.page.subtitle'), learnMore: learnMore, actions: [
                {
                    title: t('EDIT'),
                    type: 'EDIT',
                },
            ], actionHandler: actionHandler, titleSize: "medium" }),
        React.createElement(ArsenalConnectorsList, null)));
});
//# sourceMappingURL=setting-spotter-connectors.container.js.map